module.exports = __webpack_public_path__ + "static/media/ceilings_gwp_60y_y.4ced7a9b.csv";